// import React, { Fragment } from "react";
// import Header from "../../components/common/header";
// // import HeaderBot from "../../components/common/headerBot";
// import Loader from "../../components/common/loader";
// import SamiBanner from "../../components/common/samiBanner";
// import SideFilter from "../../components/common/sideFilter";
// import CouponsGrids from "../../components/common/couponsGrids";
// import WeOffer from "../../components/common/weOffer";
// import ProductLists from "../../components/common/productLists";
// import PageHeadAgileInfo from "../../components/common/pageHeadAgileInfo";
// import EnquiryForm from "../../components/common/enquiryForm";
// import HomeService from "../../services/homeService";
// import EnquiryFormModal from "../../components/common/enquiryFormModal";
// import ProductService from "../../services/productService";
// import { apiURL } from "../../utlis/config";
// import store from "store";
// import $ from "jquery";
// import { Helmet } from "react-helmet";

// class Home extends React.Component {
//   state = {
//     dataInfo: {},
//     brandList: [],
//     categoryInfo: {},
//     filter: false,
//     loader: false,
//     headerInfo: {},
//     subCategoryList: [],
//   };
//   componentDidMount() {
//     store.set("prvUrl", this.props.location.pathname);
//     this.setState({ headerInfo: store.get("header") });
//     var self = this;
//     document.addEventListener("headerInfo", function (e) {
//       // Prints "Example of an event"
//       var headerInfo = e.detail.headerInfo;
//       self.setState({ headerInfo });
//     });
//     const { match } = this.props;
//     const { params } = match;
//     console.log(this.props, "props---categoryUrl-", { params });
//     if (params.categoryUrl) {
//       this.setState({ categoryUrl: params.categoryUrl }, function () {
//         this.callApiHeader();
//         this.callApiInfo();
//       });
//     }
//   }

//   componentDidUpdate() {
//     store.set("prvUrl", this.props.location.pathname);
//     const { categoryUrl } = this.state;
//     const { match } = this.props;
//     const { params } = match;
//     console.log(this.props, "props---categoryUrl-", { params });
//     if (params.categoryUrl !== categoryUrl) {
//       this.setState({ categoryUrl: params.categoryUrl }, function () {
//         this.callApiHeader();
//         this.callApiInfo();
//       });
//     }
//   }
//   callApiHeader = () => {
//     HomeService.fetchBrandCategoryInfo().then((response) => {
//       if (!response.error) {
//         var header = store.get("header");
//         this.updateEvent(header);
//       }
//     });
//   };
//   updateEvent = (headerInfo) => {
//     var event = new CustomEvent("headerInfo", {
//       detail: { headerInfo: headerInfo },
//     });
//     document.dispatchEvent(event);
//   };
//   callApiInfo = () => {
//     this.setState(
//       { loader: true, dataInfo: [], categoryInfo: {}, totalRecords: 0 },
//       function () {
//         const { categoryUrl, filterBrands, filterSubCategories } = this.state;
//         ProductService.fetchProductsInfo(
//           undefined,
//           categoryUrl,
//           undefined,
//           undefined,
//           filterBrands,
//           filterSubCategories
//         ).then((response) => {
//           if (!response.error) {
//             this.setState({
//               dataInfo: response.data,
//               categoryInfo: response.categoryInfo,
//               subCategoryList:
//                 response.categoryInfo && response.categoryInfo.subCategory
//                   ? response.categoryInfo.subCategory
//                   : {},
//               totalRecords: response.totalRecords,
//             });
//           } else {
//             // this.props.history.push("/product");
//           }
//         });
//         this.setState({ loader: false });
//       }
//     );
//   };
//   filterToggel = () => {
//     const { filter } = this.state;
//     this.setState({ filter: !filter });
//   };

//   handleSubmit = (e) => {
//     e.preventDefault();
//     const data = new FormData(e.target);
//     const formData = {};
//     formData["name"] = data.get("name");
//     formData["email"] = data.get("email");
//     formData["contactNumber"] = data.get("contactNumber");
//     formData["countryCode"] = data.get("countryCode");
//     formData["country"] = data.get("country");
//     formData["quantity"] = data.get("quantity");
//     formData["productId"] = data.get("productId");
//     this.setState({ loader: true }, function () {
//       ProductService.sendEnqury(formData).then((response) => {
//         this.setState({ loader: false, showEnquiryFormModal: false });
//         if (!response.error) {
//           this.props.history.push("/thanks");
//         } else {
//         }
//       });
//       this.setState({ loader: false });
//     });
//   };
//   render() {
//     const {
//       dataInfo,
//       categoryInfo,
//       filter,
//       showEnquiryFormModal,
//       productInfo,
//       headerInfo,
//       subCategoryList,
//       loader,
//     } = this.state;
//     const { brandList, categoryList } = headerInfo;
//     console.log("------------------&&&&&&&&&&&&", { headerInfo });
//     const propsProductList = {
//       categoryInfo,
//       dataInfo,
//       rediractUrl: (url) => {
//         this.props.history.push(url);
//         // window.location.reload();
//       },
//       onClickEnquiry: (showEnquiryFormModal, productInfo) => {
//         this.setState({ showEnquiryFormModal, productInfo });
//       },
//     };
//     const propsEnquiryFormModal = {
//       modalShow: showEnquiryFormModal,
//       productInfo,
//       onClickToggle: () => {
//         this.setState({ showEnquiryFormModal: false });
//       },
//       onClickConfirm: this.handleSubmit,
//     };
//     const propsSideFilter = {
//       categoryList: categoryList,
//       brandList,
//       subCategoryList,
//       categoryInfo,
//       isBrand: false,
//       onBrandChange: (value) => {
//         console.log({ value });
//         this.setState(
//           {
//             filterBrands: value,
//           },
//           function () {
//             $.ajaxQ.abortAll();
//             this.callApiInfo();
//           }
//         );
//       },
//       onSubCategoryChange: (value) => {
//         console.log({ value });
//         this.setState(
//           {
//             filterSubCategories: value,
//           },
//           function () {
//             $.ajaxQ.abortAll();
//             this.callApiInfo();
//           }
//         );
//       },
//     };
//     return (
//       <Fragment>
//         {/* <PageHeadAgileInfo /> */}

//         <SamiBanner title={categoryInfo.name} subTitle={"Product"} />
//         <Helmet>
//           <meta charSet="utf-8" />
//           <title>{categoryInfo.sTitle}</title>
//           <link
//             rel="canonical"
//             href={`${"https://arabtechstore.com/"}product/${categoryInfo.fullUrl
//               }`}
//           />
//           <meta name="keyword" content={categoryInfo.sKeyword} />
//           <meta name="description" content={categoryInfo.shortDescription} />
//         </Helmet>
//         <>
//           <div class="banner-bootom-w3-agileits" style={{ padding: "25px 4%" }}>
//             <div class="row">
//               <div class="col-md-3   p-5">
//                 <div
//                   class=" single-right-left men-pro-item p-15"
//                   style={{ cursor: "pointer" }}
//                   onClick={() => this.filterToggel()}
//                 >
//                   <h3>Filter</h3>
//                   {/* right */}
//                   <i
//                     class={
//                       filter
//                         ? "fa fa-chevron-down toggle-data"
//                         : "fa fa-chevron-right toggle-data"
//                     }
//                     style={{
//                       position: "absolute",
//                       right: "14px",
//                       top: "18px",
//                     }}
//                   ></i>
//                 </div>
//               </div>
//               <div class="col-md-9 p-5">
//                 <div
//                   class=" single-right-left simpleCart_shelfItem men-pro-item p-15 "
//                   style={{ fontWeight: 600, fontSize: "1.1em" }}
//                 >
//                   <ul
//                     style={{
//                       textDecoration: "none",
//                       listStyleType: "none",
//                       display: "flex",
//                     }}
//                   >
//                     <li style={{ color: "#002b7a" }}>Home&nbsp;/</li>
//                     <li style={{ color: "#fc636b" }}>
//                       {" "}
//                       &nbsp;Product's &nbsp;
//                     </li>
//                     <li style={{ color: "#002b7a" }}>
//                       /&nbsp;{categoryInfo.name}
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//               <div class="clearfix"></div>
//             </div>

//             <div class="row">
//               {loader && <Loader />}
//               {filter && categoryInfo && (
//                 <div class="col-md-3 p-5">
//                   <div class="single-right-left simpleCart_shelfItem men-pro-item  m-t-30 p-15">
//                     <SideFilter {...propsSideFilter} />
//                   </div>
//                 </div>
//               )}
//               <div class={filter ? "col-md-9 p-5" : "col-md-12 p-5"}>
//                 {dataInfo && (
//                   <div class={"single-right-left simpleCart_shelfItem p-15"}>
//                     <ProductLists {...propsProductList} />
//                   </div>
//                 )}
//                 {!loader && dataInfo && dataInfo.length == 0 && (
//                   <div className="text-center">
//                     <img
//                       src={require("../../assets/images/noProduct.png")}
//                       alt=" "
//                     />
//                   </div>
//                 )}
//               </div>
//               <div class="clearfix"></div>
//             </div>
//           </div>
//         </>
//         {/* <CouponsGrids /> */}

//         {<EnquiryFormModal {...propsEnquiryFormModal} />}
//       </Fragment>
//     );
//   }
// }

// export default Home;


import React, { Fragment, useEffect, useState, useCallback } from "react";
import Loader from "../../components/common/loader";
import SamiBanner from "../../components/common/samiBanner";
import SideFilter from "../../components/common/sideFilter";
import ProductLists from "../../components/common/productLists";
import EnquiryFormModal from "../../components/common/enquiryFormModal";
import HomeService from "../../services/homeService";
import ProductService from "../../services/productService";
import store from "store";
import $ from "jquery";
import { Helmet } from "react-helmet";
import { useNavigate, useParams, useLocation } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  const { categoryUrl } = useParams();
  const location = useLocation();

  const [dataInfo, setDataInfo] = useState([]);
  const [categoryInfo, setCategoryInfo] = useState({});
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [filter, setFilter] = useState(false);
  const [loader, setLoader] = useState(false);
  const [headerInfo, setHeaderInfo] = useState({});
  const [filterBrands, setFilterBrands] = useState();
  const [filterSubCategories, setFilterSubCategories] = useState();
  const [showEnquiryFormModal, setShowEnquiryFormModal] = useState(false);
  const [productInfo, setProductInfo] = useState(null);

  /* -------------------- HEADER SYNC -------------------- */
  useEffect(() => {
    store.set("prvUrl", location.pathname);
    setHeaderInfo(store.get("header"));

    const handleHeaderInfo = (e) => {
      if (!e?.detail?.headerInfo) return;
      setHeaderInfo(e.detail.headerInfo);
    };

    document.addEventListener("headerInfo", handleHeaderInfo);
    return () =>
      document.removeEventListener("headerInfo", handleHeaderInfo);
  }, [location.pathname]);

  /* -------------------- API: HEADER -------------------- */
  const callApiHeader = useCallback(() => {
    HomeService.fetchBrandCategoryInfo().then((response) => {
      if (!response?.error) {
        const header = store.get("header");
        if (!header) return;

        document.dispatchEvent(
          new CustomEvent("headerInfo", {
            detail: { headerInfo: header },
          })
        );
      }
    });
  }, []);

  /* -------------------- API: PRODUCTS -------------------- */
  const callApiInfo = useCallback(() => {
    setLoader(true);
    setDataInfo([]);
    setCategoryInfo({});

    ProductService.fetchProductsInfo(
      undefined,
      categoryUrl,
      undefined,
      undefined,
      filterBrands,
      filterSubCategories
    ).then((response) => {
      if (!response?.error) {
        setDataInfo(response?.data?.products || []);
        setCategoryInfo(response?.data?.categoryInfo || {});
        setSubCategoryList(response?.data?.categoryInfo?.subCategory || [])
      }
      setLoader(false);
    });
  }, [categoryUrl, filterBrands, filterSubCategories]);

  /* -------------------- EFFECT: CATEGORY CHANGE -------------------- */
  useEffect(() => {
    if (categoryUrl) {
      callApiHeader();
      callApiInfo();
    }
  }, [categoryUrl, callApiHeader, callApiInfo]);

  /* -------------------- FILTER -------------------- */
  const filterToggle = () => setFilter((prev) => !prev);

  /* -------------------- ENQUIRY -------------------- */
  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData(e.target);
    const formData = Object.fromEntries(data.entries());

    setLoader(true);

    ProductService.sendEnqury(formData).then((response) => {
      setLoader(false);
      setShowEnquiryFormModal(false);
      if (!response?.error) navigate("/thanks");
    });
  };

  const { brandList, categoryList } = headerInfo;

  const propsProductList = {
    categoryInfo,
    dataInfo,
    rediractUrl: (url) => navigate(url),
    onClickEnquiry: (show, product) => {
      setShowEnquiryFormModal(show);
      setProductInfo(product);
    },
  };

  const propsSideFilter = {
    categoryList,
    brandList,
    subCategoryList,
    categoryInfo,
    isBrand: false,
    onBrandChange: (value) => {
      setFilterBrands(value);
      $.ajaxQ.abortAll();
    },
    onSubCategoryChange: (value) => {
      setFilterSubCategories(value);
      $.ajaxQ.abortAll();
    },
  };

  const propsEnquiryFormModal = {
    modalShow: showEnquiryFormModal,
    productInfo,
    onClickToggle: () => setShowEnquiryFormModal(false),
    onClickConfirm: handleSubmit,
  };

  /* -------------------- RENDER -------------------- */
  return (
    <Fragment>
      <SamiBanner title={categoryInfo.name} subTitle="Product" />

      <Helmet>
        <title>{categoryInfo.sTitle}</title>
        <meta name="keyword" content={categoryInfo.sKeyword} />
        <meta name="description" content={categoryInfo.shortDescription} />
        <link
          rel="canonical"
          href={`https://arabtechstore.com/product/${categoryInfo.fullUrl}`}
        />
      </Helmet>

      <div className="banner-bootom-w3-agileits" style={{ padding: "25px 4%" }}>
        {loader && <Loader />}

        <div className="row" >
          <div className="col-md-3 p-5">
            <div
              className="single-right-left men-pro-item p-15"
              onClick={filterToggle}
              style={{ cursor: "pointer" }}
            >
              <h3>Filter</h3>
              <i
                className={`fa ${filter
                  ? "fa-chevron-down"
                  : "fa-chevron-right"
                  } toggle-data`}
                style={{
                  position: "absolute",
                  right: "14px",
                  top: "18px",
                }}
              />
            </div>
          </div>

          <div class="col-md-9 p-5">
            <div
              class=" single-right-left simpleCart_shelfItem men-pro-item p-15 "
              style={{ fontWeight: 600, fontSize: "1.1em" }}
            >
              <ul
                style={{
                  textDecoration: "none",
                  listStyleType: "none",
                  display: "flex",
                }}
              >
                <li style={{ color: "#002b7a" }}>Home&nbsp;/</li>
                <li style={{ color: "#fc636b" }}>
                  {" "}
                  &nbsp;Product's &nbsp;
                </li>
                <li style={{ color: "#002b7a" }}>
                  /&nbsp;{categoryInfo?.name}
                </li>
              </ul>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>

        <div class="row">
          {loader && <Loader />}
          {filter && categoryInfo && (
            <div class="col-md-3 p-5">
              <div class="single-right-left simpleCart_shelfItem men-pro-item  m-t-30 p-15">
                <SideFilter {...propsSideFilter} />
              </div>
            </div>
          )}
          <div class={filter ? "col-md-9 p-5" : "col-md-12 p-5"}>
            {dataInfo && (
              <div class={"single-right-left simpleCart_shelfItem p-15"}>
                <ProductLists {...propsProductList} />
              </div>
            )}
            {!loader && dataInfo && dataInfo.length == 0 && (
              <div className="text-center">
                <img
                  src={require("../../assets/images/noProduct.png")}
                  alt=" "
                />
              </div>
            )}
          </div>
          <div class="clearfix"></div>
        </div>

      </div>

      <EnquiryFormModal {...propsEnquiryFormModal} />
    </Fragment>
  );
};

export default Home;

